// Although it states "prospectpro" here, NormalModuleReplacementPlugin will replace it with the correct file based on VUE_APP_TYPE.
const router = require('@/router/prospectpro').default;
export default router;

// const appType = process.env.VUE_APP_TYPE;
// let router;

// if (appType === 'prospectpro') {
//     router = require('@/router/prospectpro').default;
// } else if (appType === 'developers') {
//     router = require('@/router/developers').default;
// } else if (appType === 'search') {
//     router = require('@/router/search').default;
// } else if (appType === 'builder') {
//     router = require('@/router/builder').default;
// } else {
//     router = require('@/router/prospectpro').default;
// }

// export default router;